import { React, useState, useEffect } from 'react'
import { Toast, Picker } from 'antd-mobile'
import { RightOutline, LeftOutline } from 'antd-mobile-icons'
import { getInfo } from '../request/api'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import './NewSelectPay.css'


export default function NewSelectPay() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const nodeFun = () => { }
    nodeFun()
    return (
        <div className="pay-page">
            <div className='header'>
                <div className='backIcon' onClick={() => { navigate(-1) }}>
                    <LeftOutline />
                </div>
                <p>{t('zf1')}</p>
            </div>
            <p className="title">{t('zf2')}</p>
            <div className="list">
                <div className="item" onClick={() => navigate('/paymentOptions')}>
                    <div className="lf">
                        <div className="img">
                            <img src='/assets/images/jmb.png' alt="" />
                        </div>
                        <span>数字货币交易</span>
                    </div>
                    <RightOutline className="icon" />
                </div>

                <div className="item">
                    <div className="lf">
                        <div className="img">
                            <img src="/assets/images/visa.png" alt="" />
                        </div>
                        <span>visa card</span>
                    </div>
                    <RightOutline className="icon" />
                </div>
                <div className="item">
                    <div className="lf">
                        <div className="img">
                            <img src="/assets/images/pay.png" alt="" />
                        </div>
                        <span>paypal</span>
                    </div>
                    <RightOutline className="icon" />
                </div>
            </div>
        </div>
    )
}
